import { ROUTES } from "@utils/navigation/routes";
import { getStorage } from "@lib/platform/storage";

export const POST_AUTH_RETURN_TO_KEY = "post_auth_return_to";
export const PENDING_VERIFY_EMAIL_KEY = "pending_verify_email";

export function getSafePostAuthPath(
  candidate: string | null | undefined,
): string {
  if (!candidate) return ROUTES.HOME;

  const normalized = candidate.trim();

  if (!normalized.startsWith("/") || normalized.startsWith("//")) {
    return ROUTES.HOME;
  }

  if (normalized.startsWith("/auth") || normalized.startsWith("/onboarding")) {
    return ROUTES.HOME;
  }

  return normalized;
}

export async function persistPostAuthReturnTo(
  candidate: string | null | undefined,
): Promise<void> {
  const nextPath = getSafePostAuthPath(candidate);
  await getStorage().set(POST_AUTH_RETURN_TO_KEY, nextPath);
}

export async function consumePostAuthReturnTo(): Promise<string> {
  const storage = getStorage();
  const stored = await storage.get(POST_AUTH_RETURN_TO_KEY);
  await storage.remove(POST_AUTH_RETURN_TO_KEY);
  return getSafePostAuthPath(stored);
}

export async function setPendingVerifyEmail(email: string): Promise<void> {
  await getStorage().set(PENDING_VERIFY_EMAIL_KEY, email);
}

export async function getPendingVerifyEmail(): Promise<string | null> {
  return getStorage().get(PENDING_VERIFY_EMAIL_KEY);
}

export async function clearPendingVerifyEmail(): Promise<void> {
  await getStorage().remove(PENDING_VERIFY_EMAIL_KEY);
}
